import type { ConsentPreferences, ConsentRecord, ConsentResponse } from "@/lib/consent/types";

export const DEFAULT_CONSENT_PREFERENCES: ConsentPreferences = {
  analytics_tracking: true,
  session_replay: true,
  product_updates_email: true,
  marketing_email: true,
};

export function toConsentResponse(record: ConsentRecord | null): ConsentResponse {
  if (!record) {
    return {
      preferences: { ...DEFAULT_CONSENT_PREFERENCES },
      source: "system_default",
      created_at: null,
      updated_at: null,
      change_timestamps: {
        analytics_tracking: null,
        session_replay: null,
        product_updates_email: null,
        marketing_email: null,
      },
    };
  }

  return {
    preferences: {
      analytics_tracking: Boolean(record.analytics_tracking),
      session_replay: Boolean(record.session_replay),
      product_updates_email: Boolean(record.product_updates_email),
      marketing_email: Boolean(record.marketing_email),
    },
    source: record.source || "account_settings",
    created_at: record.created_at,
    updated_at: record.updated_at,
    change_timestamps: {
      analytics_tracking: record.analytics_tracking_updated_at,
      session_replay: record.session_replay_updated_at,
      product_updates_email: record.product_updates_email_updated_at,
      marketing_email: record.marketing_email_updated_at,
    },
  };
}
